import { RefObject, useEffect, useState } from 'react';

type Position = 'aboveViewport' | 'belowViewport' | 'inView' | null;

const useIntersectionObserver = (
  target: RefObject<HTMLElement> | HTMLElement | null,
  options: { root?: Element | Document | null; threshold: number; rootMargin?: string; initialPosition?: Position } = {
    root: null,
    threshold: 0.5,
    rootMargin: '0px',
    initialPosition: undefined,
  },
) => {
  const [position, setPosition] = useState<Position | null>(options?.initialPosition ?? null);

  useEffect(() => {
    const element = target && ('current' in target ? target.current : target);
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setPosition('inView');
      } else {
        const bounding = entry.boundingClientRect;
        const viewportHeight = window.innerHeight;

        if (bounding.top < 0) {
          setPosition('aboveViewport');
        } else if (bounding.top > viewportHeight) {
          setPosition('belowViewport');
        } else {
          setPosition(null);
        }
      }
    }, options);

    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, [target, options]);

  return position;
};

export default useIntersectionObserver;
